import api from "../service/responderExigencia.service";
import * as types from "./responderExigencia.actionTypes";
import formActions from "@common/store/form/form.actions";
import { takeEvery, call, put, select } from "redux-saga/effects";
import responderExigenciaActions from "./responderExigencia.actions";
import responderExigenciaSelector from "./responderExigencia.selectors";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.VALIDA_ANALISE_EXIGENCIA, validaAnaliseExigencia);
  yield takeEvery(types.VALIDA_UPLOAD_DOCUMENTO_EXIGENCIA, validaUploadDocumentoExigencia);
  yield takeEvery(types.REMOVER_DOCUMENTO_EXIGENCIA, removerDocumentoExigencia);
  yield takeEvery(types.POST_RESPOSTA_EXIGENCIA, postRespostaExigencia);
}

function* validaAnaliseExigencia(action) {
  try {
    const { payload } = action;

    const dto = {
      ...payload
    };

    const state = yield select(responderExigenciaSelector.responderExigencia);

    if (state?.tokenRecaptcha != "" && state?.tokenRecaptcha != undefined) {
      var result = yield call(api.validaAnaliseExigencia, dto, {
        headers: { tokenRecaptcha: state?.tokenRecaptcha}
      });

      if(result.data) {
        const dados = {...dto, ...result.data[0]};
        yield put(responderExigenciaActions.setHeaderExigencia(dados));
        yield put(responderExigenciaActions.setShowGridExigencia(result.data.length > 1));

        if(result.data.length > 1)
          yield put(responderExigenciaActions.setDataGridExigencia(result.data));
        else
          yield put(responderExigenciaActions.setFormExigencia(result.data[0]));

        yield put(formActions.gridReload());
      }
    } else {
      _alert.warning("É necessário validar o ReCaptcha.");
      yield put(formActions.redirect('redeSIM.responderExigencia'));
    }
  } catch {
    yield put(formActions.redirect('redeSIM.responderExigencia'));
  }
}

function* validaUploadDocumentoExigencia(action) {
  const { payload } = action;

  if ((payload?.DescricaoArquivo == "" || payload?.DescricaoArquivo == undefined) ||
  (payload?.Arquivo == "" || payload?.Arquivo == undefined)) {
    _alert.warning('É nescessário anexar um documento (Permitido apenas documentos no formato PDF) e informar a descrição.');
    return;
  }

  const documento = {
    DescricaoArquivo: payload?.DescricaoArquivo,
    Arquivo: payload?.Arquivo?.name,
    Documento: payload?.Arquivo,
  };

  const state = yield select(responderExigenciaSelector.responderExigencia);

  let { DataGridDocumento } = state.FormExigencia;
  let listaGridDocumentoArray = [...DataGridDocumento];

  let newGridDocumentoArray = listaGridDocumentoArray.length > 0 ?
  listaGridDocumentoArray.filter(x => x.DescricaoArquivo.toLowerCase() == payload?.DescricaoArquivo.toLowerCase()) : [];

  if (newGridDocumentoArray.length > 0) {
    _alert.warning('Descrição já incluída na resposta de exigência.');
    return;
  }

  yield put(responderExigenciaActions.setFormExigencia({ DataGridDocumento: [...state.FormExigencia.DataGridDocumento, documento]}));

  yield put(responderExigenciaActions.toggleDocumentoModal());

  yield put(formActions.gridReload());
}

function* removerDocumentoExigencia(action) {
  const { payload } = action;
  const state = yield select(responderExigenciaSelector.responderExigencia);

  let { DataGridDocumento } = state.FormExigencia;
  let listaGridDocumentoArray = [...DataGridDocumento];

  let newGridDocumentoArray = listaGridDocumentoArray.filter(x => x.Arquivo != payload.Arquivo);

  yield put(responderExigenciaActions.setFormExigencia({ DataGridDocumento: newGridDocumentoArray}));

  yield put(formActions.gridReload());
}

function* postRespostaExigencia(action) {
  const { payload } = action;
  const state = yield select(responderExigenciaSelector.responderExigencia);
  const { FormExigencia } = state;
  const { DataGridDocumento } = FormExigencia;

  let documentos = DataGridDocumento.map(doc => {
    return {
      Descricao: doc.DescricaoArquivo,
      NomeArquivo: doc.Arquivo
    }
  });

  let data = {
    ...FormExigencia,
    ...payload,
    Url: api_routes.smarAPD_FileManager_Domain + '/filemanager/Tb/DownloadDocumentoSolicitado?documento=',
    Documentos: documentos,
  }

  try {
    yield call(api.postRespostaExigencia, data);

    yield put(formActions.exigencia());

    yield put(formActions.redirect('RedeSIM'));
  } catch {
    yield put(formActions.redirect('RedeSIM'));
  }
}
